// routes/FrontendRoutes.js

import React from 'react';
import { Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import JobPostings from '../components/Frontend/AccountDetails/JobPostings/JobPostings';

export const JobPostingsRoutes = (
  <>
    <Route path="account_details/job_postings" element={<MainLayout />}>
      <Route index element={<JobPostings />} />
    </Route>
  </>
);
